export { default as FreeSwitch } from './FreeSwitch.vue';
